import { render } from "./VPAADashboard.vue?vue&type=template&id=e8a665d8&scoped=true"
import script from "./VPAADashboard.vue?vue&type=script&lang=js"
export * from "./VPAADashboard.vue?vue&type=script&lang=js"

import "./VPAADashboard.vue?vue&type=style&index=0&id=e8a665d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a665d8"]])

export default __exports__